export const defaultIconStyle = {
    height: 72,
    width: 72,
};
//# sourceMappingURL=index.js.map